import { __exports as s } from "./index132.js";
import { __require as f } from "./index112.js";
var d;
function c() {
  if (d) return s;
  d = 1;
  var l = s && s.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(s, "__esModule", { value: !0 });
  var r = l(f());
  function u(e, t) {
    return function() {
      var a = this.traits(), i = this.properties ? this.properties() : {};
      return r.default(a, "address." + e) || r.default(a, e) || (t ? r.default(a, "address." + t) : null) || (t ? r.default(a, t) : null) || r.default(i, "address." + e) || r.default(i, e) || (t ? r.default(i, "address." + t) : null) || (t ? r.default(i, t) : null);
    };
  }
  function n(e) {
    e.zip = u("postalCode", "zip"), e.country = u("country"), e.street = u("street"), e.state = u("state"), e.city = u("city"), e.region = u("region");
  }
  return s.default = n, s;
}
export {
  c as __require
};
//# sourceMappingURL=index108.js.map
